import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {productAccountEntitlementConflictChecker} from 'src/openapi/admin/apis/ProductAccountEntitlementsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {EntitlementConflictRequest} from 'src/openapi/admin/models/EntitlementConflictRequest';

type Props = {
    accountId: number,
    entitlementConflictRequest: EntitlementConflictRequest,
};

export const useGetProductAccountEntitlementsConflicts = (
    {accountId, entitlementConflictRequest}: Props,
) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        productAccountEntitlementConflictChecker({accountId, entitlementConflictRequest}),
    ), [accountId, apiDispatch, entitlementConflictRequest]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
